import {
  faqItems,
} from '../../../content/healthModalsContent';
import { registerAnalyticsRemoveFromCartEvent } from '../../../utils/analytics';
import { sideNavUsp } from './constants/sideNavUsp';

const apply = {
  name: 'apply',
  localState: {
    wizardSteps: [],
    pageError: '',
  },
  components: [
    {
      type: 'PageLayout',
      props: {
        bg: 'comparatorBG',
        paddingBottom: 80,
        header: [
          {
            type: 'PageHeader',
            props: {
              faq: {
                buttonLabel: 'Veelgestelde vragen',
                buttonIcon: 'comment',
                title: 'Veelgestelde vragen',
                items: faqItems,
                hideLabelOnMobile: true,
              },
              activeStep: 3,
            },
          },
        ],
        sideNav: [
          {
            type: 'Div',
            props: {
              width: '310px',
            },
            _children: [
              {
                type: 'ProductSummaryHealth',
                props: {
                  display: ['none', null, 'block'],
                  css: {
                    boxSizing: 'content-box',
                  },
                  mt: '11.5rem',
                  mb: 6,
                  fieldName: 'overview.selectedProduct',
                  bg: 'white',
                  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15) !important',
                  padding: 5,
                  borderRadius: 2,
                  showTransparency: false,
                  promotionBarModals: {
                    containerStyles: {
                      display: 'flex',
                      justifyContent: 'center !important',
                      marginTop: '24px',
                      padding: '8px 24px',
                      borderRadius: '16px',
                      '> div:first-child': {
                        padding: '0',
                      },
                    },
                    items: [
                      {
                        modal: {
                          contentType: 'incentive',
                          title: 'Unieke Tandongevallen-verzekering',
                          buttonSubtitle: 'Met een dekking tot € 25.000',
                          buttonIcon: 'tooth',
                          buttonIconProps: {
                            width: 18,
                            height: 18,
                            paddingLeft: 'unset',
                            minWidth: 'unset',
                            css: {
                              flexShrink: 0,
                            },
                          },
                          content: [
                            {
                              type: 'BolContent',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'Div',
                props: {
                  marginTop: 6,
                  marginBottom: [80, 0, 0, 0],
                },
                _children: [
                  {
                    type: 'AfterTheSwitchWrapper',
                    props: {
                      selectedProduct: 'overview.selectedProduct',
                      title: 'Zo werkt je aanvraag',
                    },
                  },
                ],
              },
            ],
          },
          sideNavUsp({ display: ['none', null, 'block'] }),
        ],
        subHeader: [
          {
            type: 'ProductSummaryHealth',
            props: {
              left: 0,
              right: 0,
              bottom: 0,
              position: 'fixed',
              borderTopLeftRadius: '24px',
              borderTopRightRadius: '24px',
              boxShadow: '0px -4px 10px 0px rgba(62, 72, 101, 0.10)',
              zIndex: 100,
              display: ['block', null, 'none'],
              fieldName: 'overview.selectedProduct',
              backgroundColor: 'main.0',
              py: [3, null, 5],
              px: 5,
              showTransparency: false,
              promotionBarModals: {
                containerStyles: {
                  display: 'flex',
                  justifyContent: 'center !important',
                  marginTop: '24px',
                  padding: '8px 24px',
                  borderRadius: '16px',
                  '> div:first-child': {
                    padding: '0',
                  },
                },
                items: [
                  {
                    modal: {
                      contentType: 'incentive',
                      title: 'Unieke Tandongevallen-verzekering',
                      buttonSubtitle: 'Met een dekking tot € 25.000',
                      buttonIcon: 'tooth',
                      buttonIconProps: {
                        width: 18,
                        height: 18,
                        minWidth: 'unset',
                        paddingLeft: 'unset',
                        css: {
                          flexShrink: 0,
                        },
                      },
                      content: [
                        {
                          type: 'BolContent',
                        },
                      ],
                    },
                  },
                ],
              },
            },
          },
        ],
        content: [
          {
            type: 'Div',
            props: {
              px: 0,
              fontSize: 2,
              variant: 'primaryContainer',
              background: 'none',
              boxShadow: 'none',
            },
            _children: [
              {
                type: 'GoToButtonIcon',
                props: {
                  variant: 'transparentWithIcon',
                  index: 4,
                  children: 'Terug naar overzicht',
                  registerAnalyticsRemoveFromCartEvent,
                },
              },
              {
                type: 'DynamicFormWrapper',
                props: {
                  fieldName: 'overview.selectedProduct',
                  wizardStepsKey: 'apply.wizardSteps',
                  frontEndName: 'overstappen',
                  injectedFields: {
                    'global.isMember': 'consumentenbond-userIsMember',
                    '*.isMember': 'consumentenbond-userWasAlreadyMember',
                    'global.cbLoggedIn': 'consumentenbond-loggedIn',
                    'global.isWaitingForCbApiResponse': 'currentlyChecking',
                    '*.userid': 'consumentenbond-userId',
                    '*.postcode': 'postalCode',
                    '*.birthdate': 'birthDate',
                    '*.hasIncentive': 'hasIncentive',
                    '*.numberOfChildren': 'numberOfChildren',
                    '*.insuredFamilyComposition': 'insuredFamilyComposition',
                    '*.flow': 'flow',
                  },
                  submitButtonText: 'Aanvraag versturen',
                  fieldNames: [
                    'getUserInput.deductibleAmount',
                    'getUserInput.birthdate',
                    'getUserInput.postcode',
                    'getUserInput.gender',
                    'getUserInput.partnerBirthdate',
                    'getUserInput.partnerGender',
                    'getUserInput.coverageadditions',
                    'getUserInput.childBirthdate1',
                    'getUserInput.childBirthdate2',
                    'getUserInput.childBirthdate3',
                    'getUserInput.childBirthdate4',
                    'getUserInput.childBirthdate5',
                    'getUserInput.childGender1',
                    'getUserInput.childGender2',
                    'getUserInput.childGender3',
                    'getUserInput.childGender4',
                    'getUserInput.childGender5',
                  ],
                },
              },
            ],
          },
          {
            type: 'Div',
            props: {
              display: ['block', null, 'none'],
              marginTop: 6,
            },
            _children: [
              {
                type: 'AfterTheSwitchWrapper',
                props: {
                  selectedProduct: 'overview.selectedProduct',
                  title: 'Zo werkt je aanvraag',
                },
              },
            ],
          },
          {
            type: 'AFMBanner',
          },
          sideNavUsp({ mb: '130px', display: ['block', null, 'none'] }),
        ],
        sideNavProps: {
          position: 'sticky',
          top: '20px',
          alignSelf: 'start',
        },
      },
    },
  ],
};

export default apply;
